import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import { PopupButton } from "react-calendly"

export const StoriesAndIdea = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  const [rootElement, setRootElement] = React.useState<HTMLElement | null>(null)

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const element = document.getElementById("___gatsby")
      setRootElement(element)
    }
  }, [])
  return (
    <>
      <div className="container mx-auto w-[70%] py-10 mt-10">
        <p className="lg:text-5xl md:text-2xl sm:text-sm text-[16px] text-nowrap text-black font-semibold text-center">
          Stories & Ideas
        </p>
        <div className="lg:my-4 my-2 w-full">
          <p className="text-center text-[#7B68EC] lg:text-sm text-[7px]">
            The latest news to drive business strategy
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 lg:px-0 flex flex-wrap gap-5">
        <div
          className={`lg:w-[49%] md:w-[49%] w-full p-8 rounded-2xl ${theme == "glassy" ? "bg-[#ffecd5]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#ffecd5]"}`}
        >
          <div>
            <StaticImage
              placeholder="blurred"
              className="w-full"
              src="./hand-shake.png"
              alt="life-in-future"
            />
          </div>
          <div className="w-full">
            <div className="flex justify-between items-center">
              <div className="flex gap-2 items-center pt-5">
                <div
                  className={`w-10 h-10 rounded-full ${theme == "glassy" ? "bg-[#FFFFFF73]" : theme === "light" ? "bg-completedProject bg-primary-shadow" : theme === "dark" ? "bg-completedProject bg-primary-shadow-dark" : "bg-[#FFFFFF73]"}`}
                >
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./visual-logo.png"
                    alt="clients"
                  />
                </div>
                <div>
                  <p className="text-black">Visual Folio</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 pt-1">
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./calendar.png"
                    alt="clients"
                  />
                </div>
                <p className="text-black text-start">24 January 2025</p>
              </div>
            </div>
            <div className="">
              <div className="text-center">
                <p className="text-black lg:text-2xl py-5 text-center lg:text-start font-semibold ">
                  Sealing Success – Officially Partnering for Growth!
                </p>
                <p className="text-black text-center opacity-60 text-sm lg:text-start ">
                  We're excited to take the next step in our collaboration! With
                  the contract signed, we’re officially set to bring your vision
                  to life. At Visual Folio, we believe in transparency,
                  innovation, and delivering results that drive success. Let’s
                  build something extraordinary together!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`lg:w-[49%] md:w-[49%] w-full p-8 rounded-2xl ${theme == "glassy" ? "bg-[#ffecd5]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#ffecd5]"}`}
        >
          <div>
            <StaticImage
              placeholder="blurred"
              className="w-full"
              src="./meeting.png"
              alt="life-in-future"
            />
          </div>
          <div className="w-full">
            <div className="flex justify-between items-center">
              <div className="flex gap-2 items-center pt-5">
                <div
                  className={`w-10 h-10 rounded-full ${theme == "glassy" ? "bg-[#FFFFFF73]" : theme === "light" ? "bg-completedProject bg-primary-shadow" : theme === "dark" ? "bg-completedProject bg-primary-shadow-dark" : "bg-[#FFFFFF73]"}`}
                >
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./visual-logo.png"
                    alt="clients"
                  />
                </div>
                <div>
                  <p className="text-black">Visual Folio</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 pt-1">
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./calendar.png"
                    alt="clients"
                  />
                </div>
                <p className="text-black text-start">24 January 2025</p>
              </div>
            </div>
            <div className="">
              <div className="text-center">
                <p className="text-black lg:text-2xl py-5 text-center lg:text-start font-semibold ">
                  Strategic Minds Unite – Visual Folio Office Meetup
                </p>
                <p className="text-black text-center opacity-60 text-sm lg:text-start ">
                  Step into a space where creativity meets strategy! Our team at
                  Visual Folio gathers to brainstorm, innovate, and craft
                  cutting-edge solutions for our clients. Every meeting fuels
                  collaboration, ensuring we stay ahead in delivering
                  exceptional digital experiences.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`lg:w-[49%] md:w-[49%] w-full p-8 rounded-2xl ${theme == "glassy" ? "bg-[#ffecd5]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#ffecd5]"}`}
        >
          <div>
            <StaticImage
              placeholder="blurred"
              className="w-full"
              src="./discuss.png"
              alt="life-in-future"
            />
          </div>
          <div className="w-full">
            <div className="flex justify-between items-center">
              <div className="flex gap-2 items-center pt-5">
                <div
                  className={`w-10 h-10 rounded-full ${theme == "glassy" ? "bg-[#FFFFFF73]" : theme === "light" ? "bg-completedProject bg-primary-shadow" : theme === "dark" ? "bg-completedProject bg-primary-shadow-dark" : "bg-[#FFFFFF73]"}`}
                >
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./visual-logo.png"
                    alt="clients"
                  />
                </div>
                <div>
                  <p className="text-black">Visual Folio</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 pt-1">
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./calendar.png"
                    alt="clients"
                  />
                </div>
                <p className="text-black text-start">24 January 2025</p>
              </div>
            </div>
            <div className="">
              <div className="text-center">
                <p className="text-black lg:text-2xl py-5 text-center lg:text-start font-semibold ">
                  Sealing Success with a Handshake – A Symbol of Unity &
                  Collaboration
                </p>
                <p className="text-black text-center opacity-60 text-sm lg:text-start ">
                  A handshake is more than just a gesture it’s a commitment to
                  unity, trust, and shared success. At Visual Folio, we believe
                  in building strong partnerships, where collaboration with
                  experienced leaders drives innovation and excellence.
                  Together, we create opportunities, overcome challenges, and
                  shape the future of digital transformation.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`lg:w-[49%] md:w-[49%] w-full p-8 rounded-2xl ${theme == "glassy" ? "bg-[#ffecd5]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#ffecd5]"}`}
        >
          <div>
            <StaticImage
              placeholder="blurred"
              className="w-full"
              src="./table-talk.png"
              alt="life-in-future"
            />
          </div>
          <div className="w-full">
            <div className="flex justify-between items-center">
              <div className="flex gap-2 items-center pt-5">
                <div
                  className={`w-10 h-10 rounded-full ${theme == "glassy" ? "bg-[#FFFFFF73]" : theme === "light" ? "bg-completedProject bg-primary-shadow" : theme === "dark" ? "bg-completedProject bg-primary-shadow-dark" : "bg-[#FFFFFF73]"}`}
                >
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./visual-logo.png"
                    alt="clients"
                  />
                </div>
                <div>
                  <p className="text-black">Visual Folio</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-4 pt-1">
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./calendar.png"
                    alt="clients"
                  />
                </div>
                <p className="text-black text-start">24 January 2025</p>
              </div>
            </div>
            <div className="">
              <div className="text-center">
                <p className="text-black lg:text-2xl py-5 text-center lg:text-start font-semibold ">
                  Focused Conversations, Powerful Outcomes
                </p>
                <p className="text-black text-center opacity-60 text-sm lg:text-start ">
                  At Visual Folio, we believe that meaningful discussions drive
                  success. Our focused one-on-one conversations ensure clarity,
                  align goals, and create strategies that deliver impactful
                  results. Every dialogue is a step toward growth and
                  innovation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* section-footer */}
      <div
        className={`mt-16 mb-10 py-10 rounded-2xl w-[80%] mx-auto ${theme == "glassy" ? "bg-resource-footer" : theme === "light" ? "bg-btn" : theme === "dark" ? "bg-btn" : "bg-resource-footer"}`}
      >
        <div className="text-center">
          <p className="lg:text-4xl md:text-2xl text-sm text-nowrap text-[10px] text-black font-semibold">
            Get results you’ll want <br />
            to take credit for
          </p>
          <div className="flex justify-center pt-8">
            {rootElement && (
              <PopupButton
                className="px-5 py-3 bg-header-unique-btn text-black font-inter lg:text-sm text-[7px] whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in book-free-consultancy-radius bg-btn bg-glass"
                url="https://calendly.com/visualfolio-info/30min"
                rootElement={rootElement}
                text="Book A Call"
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}
